import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector, useDispatch } from "react-redux";
import * as statusDispatch from '../../../store/dataLoader/actions';
import { getLoaderStatusPendingSelector, getLoaderStatusSelector } from "../../../store/dataLoader/selectors";
import { Grid, Modal } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { convertUTCDateToLocalDate } from '../../shared/functions'
import * as workflows from '../../../store/workFlows/actions'
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { postWorkflowsPendingSelector } from '../../../store/workFlows/selectors'

export type StatusProps = {
    batchCode: string,
    rebaseAllowed: boolean,
    enabled?: boolean
};

const LoaderStatus = (props: StatusProps) => {
    const [dataRows, setDataRows] = useState<any>([]);
    const [open, setOpen] = React.useState(false);
    const isRebaseAllowed = props.rebaseAllowed;
    const { batchCode } = props
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch()
    const statusList = useSelector(getLoaderStatusSelector);
    const statusPending = useSelector(getLoaderStatusPendingSelector);
    const workflowPending = useSelector(postWorkflowsPendingSelector);
    const [rebase, setRebase] = useState(false)
    const [running, setRunning] = useState(false)
    const [maximizedHeight, setHeightMaximized] = useState(false);
    const [maximizedWidth, setMaximizedWidth] = useState(false);

    const refreshStatus = () => {

        dispatch(statusDispatch.fetchLoaderStatusReq(batchCode));
    }

    const handleOpen = () => {
        setOpen(true)
        refreshStatus()
    };

    useEffect(() => {
        if (statusList && statusList.length > 0 && statusList !== undefined) {
            const newRows = statusList !== undefined && statusList?.map((item: any, index: number) => {
                return { ...item, id: index, batchStart: convertUTCDateToLocalDate(item.batchStart), actualLogTime: convertUTCDateToLocalDate(item.actualLogTime), exception: item.exception === null ? 'NA' : item.exception };
            });
            setDataRows(newRows);
        }
        if (statusPending !== true) {
            const filteredList = statusList && statusList?.length > 0 ? statusList?.filter((item) => { return item.status === "Executing" }) : [];

            if (filteredList && filteredList.length > 0) {
                setRunning(true);
            }
            else {
                setRunning(false);
            }
        }
    }, [statusList]);

    const runWorkflow = () => {
        const finalLoaderRun = {
            "batchCode": batchCode ? batchCode : '',
            "rebase": false
        }
        dispatch(workflows.postWorkFlowsRequest(finalLoaderRun));
        setRebase(false);
        setRunning(true);
    }

    const runRebase = () => {
        const finalLoaderRun = {
            "batchCode": batchCode ? batchCode : '',
            "rebase": true
        }
        setRebase(true)
        dispatch(workflows.postWorkFlowsRequest(finalLoaderRun));
        setRunning(true);
    }

    const style = {
        position: 'relative',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: maximizedWidth ? '100%' : '60%',
        background: 'white',
        height: maximizedHeight ? '100%' : '60%',
        p: 4,
    };

    const toggleMaximize = () => {
        setHeightMaximized(!maximizedHeight);
        setMaximizedWidth(!maximizedWidth);
    };

    const buttonStyle = {
        background: 'white',
        ml: { xs: -1, sm: -2, md: -3, lg: -4 },
        mr: { xs: -1, sm: -2, md: -3, lg: -4 },
        mt: { xs: 0, sm: 1, md: 2, lg: 3 },
        p: 1.5,
    };

    return (
        <>
            {isRebaseAllowed ?
                <>
                    {workflowPending && !rebase ?
                        <LoadingButton loading loadingPosition="start" variant="outlined" sx={{ m: 1 }} startIcon={<SaveIcon />} >Processing </LoadingButton>
                        :
                        <Button id="12b98da5-3757-4de9-9592-8110e5c74d18" color="primary" variant="contained" onClick={runWorkflow} disabled={running || !props.enabled} sx={{ m: 1 }}>
                            Run now  </Button>}
                    {workflowPending && rebase ?
                        <LoadingButton loading loadingPosition="start" variant="outlined" sx={{ m: 1 }} startIcon={<SaveIcon />} >Processing </LoadingButton>
                        :
                        <Button id="17ce8837-cd04-4a7b-8061-b83432ec20b8" color="primary" variant="contained" onClick={runRebase} disabled={running || !props.enabled} sx={{ m: 1 }}>
                            Run now (rebase)</Button>
                    }
                </> : <>
                </>}

            <Button id="1a637944-c90f-43ed-a70f-c124c664bbd8"
                color="primary"
                variant="contained"
                onClick={handleOpen}
                sx={{ m: 1 }}
            >
                Loader Status
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                    <Box sx={style}>
                        {statusPending ?
                            <Grid container width="100%">
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton animation="wave" height={60} />
                                </Grid>

                            </Grid> :
                        <Typography id="modal-modal-description">
                                <DataGrid
                                    pagination
                                    rows={dataRows}
                                    sortingOrder={['asc', 'desc']}
                                    initialState={{
                                        sorting: {
                                            sortModel: [{ field: 'batchStart', sort: 'desc' }],
                                        },
                                    }}
                                    rowsPerPageOptions={[30, 50, 100]}
                                    columns={[
                                        {
                                            field: 'batchStart',
                                            headerName: 'Start Time',
                                            width: 150,
                                        },
                                        {
                                            field: 'status',
                                            headerName: 'Status',
                                            width: 150,
                                        },
                                        {
                                            field: 'exception',
                                            headerName: 'Exception',
                                            width: 350,
                                        },
                                        {
                                            field: 'runTimeInSeconds',
                                            headerName: 'Run Time',
                                            width: 150,
                                        },
                                        {
                                            field: 'isRebase',
                                            headerName: 'Rebase',
                                            width: 150,
                                        },
                                        {
                                            field: 'recordCount',
                                            headerName: 'Record Count',
                                            width: 150,
                                        },

                                    ]}

                                />
                                <Box sx={buttonStyle} display="flex" justifyContent="flex-end">
                                    <Button id="fab7dd25-e83d-4c25-ae55-35667ff23d30" color="primary" variant="contained" onClick={refreshStatus} >Refresh</Button>
                                    <Button id="1188ae97-871f-43f1-a1fc-a353a9bd6c8b" color="primary" variant="contained" onClick={handleClose} sx={{ ml: 2 }}>Close</Button>
                                <Button color="primary" variant="contained" onClick={toggleMaximize} sx={{ ml: 1 }}>{maximizedHeight ? 'Minimize' : 'Maximize'}</Button>    
                            </Box>
                            </Typography>
                    }
                    </Box>
            </Modal>
        </>
    )
};

export default LoaderStatus;